/* import libraries */
import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

/* import components */
import './App.css';
import ArticleHelpForm from './pages/ArticleHelpForm';
import Home from './pages/Home';
import IssueDetails from './pages/IssueDetails';
import IssueHistory from './pages/IssueHistory';
import SectionArticleList from './pages/SectionArticleList';
import TripDetails from './pages/TripDetails';
import TripHistory from './pages/TripHistory';
import { setDatadogUserID } from './utils/utils';

function App() {

  const queryClient = new QueryClient();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setDatadogUserID(token);
    }
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/*" element={<Home />} />
            <Route path="/triphistory" element={<TripHistory />} />
            {["/trip/:tripId",
              "/topic/:serviceType/:tripId",
              "/sections/:sectionId"].map((path, index) => {
              return (
                <Route path={path} element={<TripDetails />} key={index} />
            )})}
            <Route path="/trip/:tripId/sections/:sectionId" element={<SectionArticleList />} />
            <Route path="/issuehistory" element={<IssueHistory />} />
            <Route path="/issue/:ticketId" element={<IssueDetails />} />
            {["/trip/:tripId/topic/:articleId",
              "/topic/:articleId",
              "/topic/:serviceType/:tripId/topic/:articleId",
              "/sections/:sectionId/topic/:articleId"].map((path, index) => {
              return (
                <Route path={path} element={<ArticleHelpForm />} key={index} />
            )})}
          </Routes>
        </Router>
      </div>
      </QueryClientProvider>
  );
}

export default App;
